<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/02/1.png')"
      ></van-image>
      <div class="bodywarp">
        <div class="bodytestwarp">
          <div class="setp1warp">
            <div>
              <van-image
                class="testImage"
                :src="require('../../../../public/image/02/STEP1.png')"
              >
              </van-image>
            </div>
            <div>
              <van-image
                class="STEP1logo"
                :src="require('../../../../public/image/02/1/1.png')"
              >
              </van-image>
            </div>
            <van-field
              id="setp1warp"
              class="phone"
              v-model="newPhone"
              placeholder="輸入手機號"
            >
              <template #label>
                <van-dropdown-menu
                  :overlay="false"
                  active-color="rgb(114, 43, 17)"
                >
                  <van-dropdown-item
                    get-container="body"
                    v-model="areatype"
                    :options="option"
                  />
                </van-dropdown-menu>
              </template>
            </van-field>
            <div class="checked">
              <van-checkbox icon-size="12px" v-model="checked" shape="square">
                <template #icon="props">
                  <img
                    v-if="!props.checked"
                    class="img-icon1"
                    :src="require('../../../../public/image/13/01/4.png')"
                  />
                  <div class="checkImage" v-else>
                    <img
                      class="img-icon"
                      :src="require('../../../../public/image/13/01/4.png')"
                    />
                    <img
                      class="img-icon"
                      :src="require('../../../../public/image/13/01/5.png')"
                    />
                  </div>
                </template>
                <van-image
                  :src="require('../../../../public/image/13/01/3.png')"
                >
                </van-image>
              </van-checkbox>
            </div>
            <div class="button">
              <a href="javascript:;" @click="Purchase">
                <van-image :src="require('../../../../public/image/02/3.png')">
                </van-image>
              </a>
            </div>
          </div>
          <div class="setp2warp">
            <div>
              <van-image
                class="testImage"
                :src="require('../../../../public/image/02/STEP2.png')"
              >
              </van-image>
            </div>
            <div class="flex">
              <van-image
                class="flexImage"
                :src="require('../../../../public/image/02/4.png')"
              >
              </van-image>
              <van-image
                class="flexImage"
                :src="require('../../../../public/image/02/5.png')"
              >
              </van-image>
            </div>
            <div class="button" v-if="isMobile">
              <a
                href="https://crossgatetw.onelink.me/0CmU/mobile"
                target="_black"
                @click="Subscribe"
              >
                <van-image
                  class="flexImage"
                  :src="require('../../../../public/image/02/6.png')"
                >
                </van-image>
              </a>
            </div>
            <div v-else class="buttonwarp1">
              <a
                href="https://crossgatetw.onelink.me/0CmU/ios"
                target="_black"
                @click="Subscribe"
              >
                <van-image
                  :src="require('../../../../public/image/01/5.png')"
                ></van-image>
              </a>
              <a
                href="https://crossgatetw.onelink.me/0CmU/google"
                target="_black"
                @click="AddPaymentInfo"
              >
                <van-image
                  :src="require('../../../../public/image/01/2.png')"
                ></van-image>
              </a>
            </div>
          </div>
          <div class="setp3warp">
            <div>
              <van-image
                class="testImage"
                :src="require('../../../../public/image/02/STEP3.png')"
              >
              </van-image>
            </div>
            <div class="flex">
              <van-image
                class="flexImage"
                :src="require('../../../../public/image/02/7.png')"
              >
              </van-image>
              <van-image
                class="flexImage"
                :src="require('../../../../public/image/02/8.png')"
              >
              </van-image>
            </div>
            <div class="flex1">
              <a href="javascript:;" @click="facebookShare">
                <!-- <div
                  class="fb-like"
                  data-href="http://192.168.110.27:8082/crossgate.tw/prereg"
                  data-width="200"
                  data-layout="button_count"
                  data-action="like"
                  data-size="large"
                  data-show-faces="false"
                  data-share="false"
                ></div> -->
                <van-image
                  class="flexImage1"
                  :src="require('../../../../public/image/02/9.png')"
                >
                </van-image>
              </a>
              <a href="javascript:;" @click="facebookShare1">
                <van-image
                  class="flexImage1"
                  :src="require('../../../../public/image/02/10.png')"
                >
                </van-image>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="footerIsShow">
      <div :class="{ mobile: isMobile, pc: !isMobile, footerWarp: true }">
        <van-image
          class="warp"
          :src="showFooterImage.backgroundImage"
        ></van-image>
        <div
          :class="{
            mobileButton: isMobile,
            pcButton: !isMobile,
            buttonwarp: true
          }"
        >
          <!-- <van-image
            v-if="showFooterImage.backgroundText"
            class="image"
            :src="showFooterImage.backgroundText"
          ></van-image> -->
          <a
            v-if="
              !showFooterImage.backgroundButtonList &&
              showFooterImage.url !== 'javascript:;'
            "
            :href="showFooterImage.url"
            target="_black"
            :class="{
              showFooterImage: showFooterImage.click === 'Apple'
            }"
            @click="clickMe1(showFooterImage.click)"
          >
            <van-image :src="showFooterImage.backgroundButton"></van-image>
          </a>
          <a
            v-else-if="
              !showFooterImage.backgroundButtonList &&
              showFooterImage.url === 'javascript:;'
            "
            href="javascript:;"
            :class="{
              showFooterImage: showFooterImage.click === 'Apple'
            }"
            @click="clickMe1(showFooterImage.click)"
          >
            <van-image :src="showFooterImage.backgroundButton"></van-image>
          </a>
          <div v-else class="backgroundButtonList">
            <a
              v-for="item in showFooterImage.backgroundButtonList"
              :key="item.url"
              :href="item.url"
              target="_black"
              @click="clickMe1(item.click)"
            >
              <van-image :src="item.backgroundButton"></van-image>
            </a>
          </div>
        </div>
      </div>
    </div>
    <SimpleDialog
      :backgroundImage="require('../../../../public/image/12/3/1.png')"
      :removeImage="require('../../../../public/image/12/3/3.png')"
      :textImage="require('../../../../public/image/12/3/2.png')"
      :visible.sync="showEasy"
      @changeVisible="showEasy = !showEasy"
    />
  </div>
</template>
<script>
import isMobile from '../../../../utils/isMobile.js'
import getData from '../../../../utils/request/request'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import SimpleDialog from '../components/simpleDialog/index.vue'
import browser from '../../../../utils/browser.js'
import getButton from '../../../../utils/getButton'

export default {
  components: {
    SimpleDialog
  },
  props: {
    footerIsShow: Boolean,
    newAreatype: Number,
    newPhone1: String
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus', 'tel'])
  },
  created() {
    if (this.isMobile) {
      let obj = {
        backgroundImage: require('../../../../public/image/03/5/1.png'),
        backgroundButton: require('../../../../public/image/03/5/4.png'),
        url: 'https://crossgatetw.onelink.me/0CmU/mobile',
        click: 'Subscribe',
        title: '懸浮-蘋果商店預約'
      }
      this.$set(this.footerList, this.footerList.length, obj)
    } else {
      let obj = {
        backgroundImage: require('../../../../public/image/03/5/1.png'),
        backgroundButtonList: [
          {
            backgroundButton: require('../../../../public/image/03/5/2.png'),
            click: 'Subscribe',
            url: 'https://crossgatetw.onelink.me/0CmU/ios',
            title: '懸浮-蘋果商店預約'
          },
          {
            backgroundButton: require('../../../../public/image/03/5/3.png'),
            click: 'AddPaymentInfo',
            url: 'https://crossgatetw.onelink.me/0CmU/google',
            title: '懸浮-谷歌商店預約'
          }
        ],
        url: 'https://www.facebook.com/groups/455633360270875'
      }
      this.$set(this.footerList, this.footerList.length, obj)
    }
  },
  data() {
    return {
      browser: browser(),
      isMobile: isMobile(),
      timeFn: null,
      index: 0,
      showFooterImage: {},
      newPhone: '',
      checked: true,
      showEasy: false,
      option: [
        { text: '台灣+886', value: 0 },
        { text: '香港+852', value: 1 },
        { text: '澳门+853', value: 2 }
        // { text: '新加坡+65', value: 3 },
        // { text: '馬來西亞+60', value: 4 }
      ],
      areatype: 0,
      footerList: [
        // {
        //   backgroundImage: require('../../../../public/image/03/5/1.png'),
        //   backgroundButtonList: [
        //     {
        //       url: require('../../../../public/image/03/5/2.png'),
        //       click: ''
        //     },
        //     {
        //       url: require('../../../../public/image/03/5/3.png'),
        //       click: ''
        //     }
        //   ],
        //   url: 'https://www.facebook.com/groups/455633360270875'
        // },
        {
          backgroundImage: require('../../../../public/image/03/1/1.png'),
          backgroundButton: require('../../../../public/image/03/1/3.png'),
          click: 'facebookShare1',
          url: 'javascript:;',
          title: '懸浮-加入FB社團按鈕-加入按鈕'
        },
        {
          backgroundImage: require('../../../../public/image/03/2/1.png'),
          backgroundButton: require('../../../../public/image/03/2/3.png'),
          url: 'javascript:;',
          click: 'facebookShare',
          title: '懸浮-點讚FB粉絲頁彈窗-點讚按鈕'
        },
        {
          backgroundImage: require('../../../../public/image/03/6/3.png'),
          backgroundButton: require('../../../../public/image/03/6/1.png'),
          url: 'javascript:;',
          click: 'scrollIntoView',
          title: '懸浮-立即預約彈窗-預約按鈕'
        }
      ]
    }
  },
  watch: {
    tel: {
      handler(val) {
        this.newPhone = val.tel
        this.areatype = val.areatype
      },
      immediate: true,
      deep: true
    },
    footerIsShow(val) {
      if (val) {
        this.showcontent()
      } else {
        clearTimeout(this.timeFn)
      }
    }
  },
  methods: {
    getButton(val) {
      getButton(val)
    },
    async scrollIntoView() {
      this.$emit('scrollIntoView', '#Activity02')
    },
    async send_gift() {
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        type: 'fbaz',
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        if (this.browser.iPhone) {
          window.location.href = 'fb://page/?id=300708233116513'
        } else if (this.browser.android) {
          window.open('fb://page/300708233116513')
        } else {
          window.open('https://www.facebook.com/CrossGate.TW/')
        }
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async facebookShare() {
      getButton('預約頁-點讚FB粉絲頁彈窗-點讚按鈕')
      await this.send_gift()
    },
    async send_gift1() {
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        type: 'fbst',
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        if (this.browser.iPhone) {
          window.location.href = 'fb://group/?id=455633360270875'
        } else if (this.browser.android) {
          window.open('fb://group/455633360270875')
        } else {
          window.open('https://www.facebook.com/groups/455633360270875')
        }
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async facebookShare1() {
      getButton('預約頁-加入FB社團按鈕-加入按鈕')
      await this.send_gift1()
    },
    async Purchase() {
      getButton('立即預約')
      if (this.checked) {
        let Api = {
          url: '/api/phone_yuyue',
          type: 'post'
        }
        let form = {
          utm: this.$route.query.utm_source ? this.$route.query.utm_source : '',
          phone: this.newPhone,
          areatype: this.areatype
        }
        let res = await getData(this.$http(Api, form))
        if (res.code === 1) {
          Toast(res.msg)
          await this.$emit('getStatus')
          this.$store.commit('changePhone', res.phone)
          this.$store.commit('changeTel', {
            tel: this.newPhone,
            areatype: this.areatype
          })
          this.$emit('yySuccess')
          fbq('track', 'Purchase')
          ttq.track('AddToWishlist')
        } else {
          switch (res.msg) {
            case '您輸入的手機號格式錯誤':
              this.showEasy = true
              break
            default:
              Toast(res.msg)
              break
          }
        }
      } else {
        Toast('請勾選同意個人資料')
      }
    },
    clickMe1(val) {
      this[val]()
    },
    async Subscribe() {
      fbq('track', 'Subscribe')
      ttq.track('CompleteRegistration')
      getButton('蘋果商店預約')
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        phone: this.phone,
        type: 'shopyuyue'
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        Toast(res.msg)
        this.$emit('getStatus')
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async AddPaymentInfo() {
      fbq('track', 'AddPaymentInfo')
      ttq.track('AddPaymentInfo')
      getButton('谷歌商店預約')
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        phone: this.phone,
        type: 'shopyuyue'
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        Toast(res.msg)
        this.$emit('getStatus')
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    showcontent() {
      this.index = 0
      this.showFooterImage = this.footerList[this.index]
      let _this = this
      this.timeFn = window.setInterval(() => {
        if (_this.index + 1 >= _this.footerList.length) {
          _this.index = -1
        }
        _this.index++
        _this.showFooterImage = _this.footerList[_this.index]
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-dropdown-menu__bar {
  height: 22px;
  box-shadow: none;
  color: rgb(114, 43, 17);
  text-align: center;
  font-weight: 550;
}
/deep/ .van-dropdown-menu__title {
  color: rgb(114, 43, 17);
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent rgb(114, 43, 17) rgb(114, 43, 17);
}
/deep/ .van-dropdown-item {
  top: 188px !important;
  // padding: 0 17% 0 15%;
}
/deep/ .van-cell::after {
  border-bottom: 2px solid #fff;
}
/deep/ .van-dropdown-item__content {
  top: 0px;
  width: 270px;
  left: calc(50% - 5px);
  transform: translateX(-50%);
  border-radius: 10px;
  border: 2px solid rgb(114, 43, 17);
  box-sizing: border-box;
}
/deep/ .van-dropdown-item__option--active {
  font-weight: 550;
}
/deep/ .van-field__value {
  border-left: 1px solid rgb(114, 43, 17);
}
/deep/ .van-field__label {
  width: 120px;
}
/deep/ .van-field {
  // margin-top: 10px;
  width: 100%;
  border-radius: 2rem;
  border: 2px solid rgb(114, 43, 17);
  color: rgb(114, 43, 17);
  padding: 5px 0px;
  .van-field__control {
    padding: 0px 16px;
    color: rgb(114, 43, 17);
  }
  /deep/ .van-field__title {
    margin-right: 0;
    padding-right: 12px;
  }

  .van-field__control::placeholder {
    text-align: center;
    color: rgb(114, 43, 17);
    font-size: 1rem;
    font-weight: 550;
  }
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes heartbeat1 {
  0% {
    transform: translateY(-30%) scale(1);
  }
  50% {
    transform: translateY(-30%) scale(1.1);
  }
  100% {
    transform: translateY(-30%) scale(1);
  }
}

.topLogo {
  width: 80%;
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
}
.bodywarp {
  background: url(../../../../public/image/02/2.png) no-repeat;
  background-size: 100% 100%;
  width: 360px;
  margin: 0 auto;
  padding: 50px 50px 40px 40px;
  box-sizing: border-box;
  .bodytestwarp {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-content: space-around;
    flex-wrap: wrap;
    .setp1warp {
      position: relative;
      overflow: hidden;
      .testImage {
        width: 100%;
      }
      /deep/ .van-checkbox__icon {
        background: #fff;
        // border-radius: 0.2rem;
        .van-icon {
          border: 0px solid #fff;
        }
      }
      /deep/ .van-checkbox__label {
        margin-left: 3px;
      }

      .checked {
        // top: 66%;
        // position: absolute;
        padding-top: 30px;
        // margin-top: 10px;
        .img-icon1 {
          height: 14px;
          position: relative;
        }
        /deep/ .van-checkbox__icon {
          width: 14px;
          height: 14px;
        }
        .checkImage {
          position: relative;
          height: 14px;
          width: 14px;
          img {
            position: absolute;
            top: 0;
            left: 0;
          }
          img:nth-child(1) {
            width: 14px;
            height: 14px;
          }
        }
        /deep/ .van-checkbox__label {
          line-height: 12px;
          display: inline-block;
          .van-image {
            margin-left: 5px;
            height: 12px;
            width: 190px;
          }
        }
        /deep/ .van-icon-success {
          border-radius: 0.2rem;
        }
      }
      .phone {
        position: absolute;
        // width: 100%;
        top: 95px;
        // border-radius: 2rem;
        // border: 2px solid rgb(114, 43, 17);
        // color: rgb(114, 43, 17);
        // padding: 5px 0px;
        .van-cell__title {
          // margin-right: 0px;
          // color: rgb(114, 43, 17);
          // font-size: 1rem;
          // border-right: 1px solid rgb(114, 43, 17);
          // width: 5.5rem;
          // text-align: center;
          // font-weight: 550;
        }
        .van-field__control {
          // padding: 0px 16px;
          // color: rgb(114, 43, 17);
        }
        .van-field__control::placeholder {
          // text-align: center;
          // color: rgb(114, 43, 17);
          // font-size: 1rem;
          // font-weight: 550;
        }
      }
      .button {
        padding: 0.5rem 2rem;
        animation: heartbeat 1s ease infinite;
      }
      .STEP1logo {
        width: 100%;
        padding: 0rem 2rem;
        box-sizing: border-box;
      }
    }
    .setp2warp {
      .flex {
        margin-top: 0.2rem;
        display: flex;
        justify-content: space-around;
        .flexImage {
          width: 30%;
        }
      }
      .button {
        padding: 0rem 2rem;
        animation: heartbeat 1s ease infinite;
      }
    }
    .setp3warp {
      position: relative;
      margin-bottom: 30px;
      .flex {
        display: flex;
        justify-content: space-around;
        .flexImage:nth-child(1) {
          width: 45%;
          display: block;
        }
        .flexImage:nth-child(2) {
          width: 45%;
          display: block;
          /deep/ .van-image__img {
            height: 80%;
            margin-top: 10%;
          }
        }
      }
      .flex1 {
        position: absolute;
        top: 125px;
        display: flex;
        justify-content: space-around;
        a {
          width: 45%;
          .flexImage1 {
            // width: 45%;
          }
        }
      }
    }
  }
}
.body {
  &::before {
    content: '';
    display: table;
  }
  position: relative;
  width: 100%;
  // height: 100vh;
  background: url(../../../../public/image/10/02.jpg) no-repeat;
  background-size: 100% 100%;
}
.buttonwarp1 {
  display: flex;
  justify-content: space-around;
  margin: 5px 0px;
  a {
    width: 45%;
    display: block;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 10000;
  .pc {
    width: calc(8 / 15 * 100vh);
    height: calc((8 / 15 * 100vh) * 23 / 125);
  }
  .mobile {
    width: 100vw;
    height: calc(100vw * 23 / 125);
  }
  .footerWarp {
    position: relative;
    overflow: hidden;
    width: 100%;

    .warp {
      position: absolute;
      top: 0rem;
      height: 100%;
      width: 100%;
    }
    .mobileButton {
      width: 100vw;
    }
    .pcButton {
      width: calc(8 / 15 * 100vh);
    }
    .buttonwarp {
      position: relative;
      height: 100%;
      /deep/ .image {
        position: absolute;
        top: 60%;
        left: 35%;
        width: 20%;
        transform: translateY(-50%);
      }
      > a {
        display: block;
        position: absolute;
        top: 55%;
        right: 5%;
        width: 30%;
        transform: translateY(-30%);
        animation: heartbeat1 1s ease infinite;
        /deep/ .van-image {
          width: 100%;
        }
      }
      > .showFooterImage {
        width: 35%;
      }
      .backgroundButtonList {
        display: flex;
        // align-items: flex-end;
        width: 37%;
        position: absolute;
        justify-content: space-between;
        right: 3%;
        top: 65%;
        transform: translateY(-30%);
        a {
          animation: heartbeat1 1s ease infinite;
          width: 47%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity02/index.vue